import React from 'react';
import { SidebarInset } from './ui/sidebar';
import { ViewHeader } from './ViewHeader';
import { ProjectBreadcrumb } from './ProjectBreadcrumb';
import { useLocale } from '../contexts/LocaleContext';
import { useIsMobile } from '../hooks/use-mobile';
import { APP_VIEWPORT_HEIGHT, projectPanelPadding } from '../constants/layout';

const insetStyle: React.CSSProperties = {
  height: APP_VIEWPORT_HEIGHT,
  overflowX: 'hidden',
  minWidth: 0,
};

export interface ProjectPanelLayoutProps {
  title: React.ReactNode;
  titleIcon?: React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
}

export const ProjectPanelLayout: React.FC<ProjectPanelLayoutProps> = ({
  title,
  titleIcon,
  actions,
  children = null,
  loading = false,
}) => {
  const { t } = useLocale();
  const isMobile = useIsMobile();
  const panelPadding = projectPanelPadding(isMobile);

  const mainPanelStyle: React.CSSProperties = {
    padding: panelPadding,
    backgroundColor: 'var(--background)',
    width: '100%',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  };

  return (
    <SidebarInset style={insetStyle} className="max-w-full">
      <ViewHeader marginBottom="0" showSidebarToggle pageActions={actions}>
        <ProjectBreadcrumb pageTitle={title} pageIcon={titleIcon} />
      </ViewHeader>
      <div style={mainPanelStyle} data-testid="project-panel-main">
        {loading ? (
          <div style={{ padding: panelPadding, textAlign: 'center', color: 'var(--muted-foreground)' }}>
            {t('loading')}
          </div>
        ) : (
          children
        )}
      </div>
    </SidebarInset>
  );
};
